module.exports = __webpack_public_path__ + "assets-cabinet/img/select-arrow-ico.7dad7286.svg";